import { BagIcon } from "@phosphor-icons/react";
import { cn } from "../../utils";
import Thumbnail, { ThumbnailProps } from "./Thumbnail";

type ProductThumbnailProps = ThumbnailProps;
export function ProductThumbnail(props: ProductThumbnailProps) {
  return (
    <Thumbnail
      NoImageIcon={BagIcon}
      {...props}
      className={cn(props.className, "aspect-square")}
    />
  );
}
